<template>
    <div class="layout" id="myComponentDiv">
        <div class="box-titulo">Parámetros avanzados para Colombia</div>

        <br />

        <div class="box-container">
            <div id="reporte">
                <div class="tabs">
                    <button :class="{ active: tab === 'combustible' }" @click="tab = 'combustible'">
                        Combustibles
                    </button>

                    <button :class="{ active: tab === 'electronica' }" @click="tab = 'electronica'">
                        Facturación Electrónica
                    </button>
                </div>

                <div v-show="tab === 'combustible'">
                    <BanderaSelector v-model="bandera" />
                    <div class="pad10">
                        <PetromilConfig v-if="bandera === 'PETROMIL'" :petromil="petromil"
                            @update:petromil="petromil = $event" />

                        <PrimaxConfig v-else-if="bandera === 'PRIMAX'" :primax="primax"
                            @update:primax="primax = $event" />

                        <TerpelConfig v-else-if="bandera === 'TERPEL'" :terpel="terpel"
                            @update:terpel="terpel = $event" />

                        <div v-else class="pad10">
                            <strong>{{ bandera || "Sin proveedor seleccionado" }}</strong><br>
                            No existe configuración adicional para este proveedor.
                        </div>
                    </div>
                </div>

                <div v-show="tab === 'electronica'">
                    <ElectronicaConfig :electronica="electronica" @update:electronica="electronica = $event" />
                </div>
            </div>

            <div class="text-right mt-4">
                <button class="btn btn-primary" @click="guardarParametros">
                    Guardar Cambios
                </button>
            </div>

            <div v-if="!permiso_lista">
                {{ person.nombre }}, {{ GLOBAL.MENSAJE?.SIN_AUTORIZACION || "Sin autorización" }}
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import GLOBAL from "../../Global.js";
import BanderaSelector from "./components/colombia/BanderaSelector.vue";
import PetromilConfig from "./components/colombia/PetromilConfig.vue";
import TerpelConfig from "./components/colombia/TerpelConfig.vue";
import PrimaxConfig from "./components/colombia/PrimaxConfig.vue";

import ElectronicaConfig from "./components/colombia/ElectronicaConfig.vue";

export default {
    name: "ParametrosColombia",

    components: {
        BanderaSelector,
        TerpelConfig,
        PrimaxConfig,
        PetromilConfig,
        ElectronicaConfig
    },

    data() {
        return {
            GLOBAL,
            person: {},
            permiso_lista: false,
            tab: "combustible",

            bandera: "",

            petromil: {
                energia_ruta: {
                    usuario: "",
                    clave: "",
                    codigo_eds: "",
                    produccion: false
                },
                homologaciones_productos: []
            },
            electronica: {
                proveedor: "",
                url: "",
                apikey: "",
                usuario: "",
                clave: "",
                correo_emisor: ""
            }
        };
    },

    created() {
        this.person = JSON.parse(sessionStorage.getItem(GLOBAL.SESSION_KEY)) || {};

        this.permiso_lista = this.person.funciones &&
            this.person.funciones.includes(GLOBAL.PERMISOS.REPORTE.HOROMETRO);

        this.getParametros();
    },

    methods: {
        crearFilaHomologacion() {
            return {
                codigo_producto_local: "",
                codigo_producto_proveedor: "",
                nombre_local: "",
                nombre_proveedor: "",
            };
        },

        agregarHomologacion() {
            this.petromil.homologaciones_productos.push(this.crearFilaHomologacion());
        },

        eliminarHomologacion(index) {
            this.petromil.homologaciones_productos.splice(index, 1);
        },

        limpiarHomologaciones(lista) {
            if (!Array.isArray(lista)) return [];

            return lista
                .map((item) => ({
                    codigo_producto_local: item?.codigo_producto_local || "",
                    codigo_producto_proveedor: item?.codigo_producto_proveedor || "",
                    nombre_local: item?.nombre_local || "",
                    nombre_proveedor: item?.nombre_proveedor || "",
                }))
                .filter(
                    (item) =>
                        item.codigo_producto_local ||
                        item.codigo_producto_proveedor ||
                        item.nombre_local ||
                        item.nombre_proveedor
                );
        },

        getParametros() {
            const url = GLOBAL.API_GET_LISTA_ATRIBUTOS_EMPRESA;

            axios
                .get(url.trim(), {
                    headers: {
                        "Content-Type": "application/json;charset=UTF-8",
                        Authorization: "Basic " + this.person.token,
                        Environment:
                            "empresas" in this.person
                                ? this.person.empresas
                                : this.person.empresa || this.person.empresas,
                    },
                })
                .then((response) => {
                    const p = response.data?.parametros || {};

                    this.bandera = p.bandera || "";

                    this.petromil = {
                        energia_ruta: {
                            usuario: p.petromil?.energia_ruta?.usuario || "",
                            clave: p.petromil?.energia_ruta?.clave || "",
                            codigo_eds: p.petromil?.energia_ruta?.codigo_eds || "",
                            produccion: p.petromil?.energia_ruta?.produccion || false,
                        },
                        homologaciones_productos: this.limpiarHomologaciones(
                            p.petromil?.homologaciones_productos || []
                        ),
                    };

                    this.electronica = {
                        proveedor: p.electronica?.proveedor || "",
                        url: p.electronica?.url || "",
                        apikey: p.electronica?.apikey || "",
                        usuario: p.electronica?.usuario || "",
                        clave: p.electronica?.clave || "",
                        correo_emisor: p.electronica?.correo_emisor || ""
                    };
                })
                .catch((error) => {
                    console.error("Error cargando parámetros:", error);
                });
        },

        guardarParametros() {
            const url = GLOBAL.API_GET_LISTA_ATRIBUTOS_EMPRESA;

            const parametros = {
                bandera: this.bandera,
            };

            if (this.bandera === "PETROMIL") {
                parametros.petromil = {
                    energia_ruta: {
                        usuario: this.petromil.energia_ruta.usuario,
                        clave: this.petromil.energia_ruta.clave,
                        codigo_eds: this.petromil.energia_ruta.codigo_eds,
                        produccion: this.petromil.energia_ruta.produccion,
                    },
                    homologaciones_productos: this.limpiarHomologaciones(
                        this.petromil.homologaciones_productos
                    ),
                };
            }

            parametros.electronica = JSON.parse(JSON.stringify(this.electronica));

            axios
                .put(
                    url,
                    { parametros },
                    {
                        headers: {
                            "Content-Type": "application/json;charset=UTF-8",
                            Authorization: "Basic " + this.person.token,
                            Environment:
                                "empresas" in this.person
                                    ? this.person.empresas
                                    : this.person.empresa || this.person.empresas,
                        },
                    }
                )
                .then(() => {
                    alert("Parámetros actualizados correctamente.");
                })
                .catch((error) => {
                    console.error("Error al actualizar parámetros:", error);
                    alert("Error al actualizar los parámetros.");
                });
        },
    },
};

</script>

<style scoped src="./ParametrosColombia.css"></style>